export default "__VITE_ASSET__DORMLq8w__"